import { render, staticRenderFns } from "./DialogSolicitarRetirada.vue?vue&type=template&id=4550ba9c&"
import script from "./DialogSolicitarRetirada.vue?vue&type=script&lang=js&"
export * from "./DialogSolicitarRetirada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports